<div
    id="kt_quick_sidebar_toggle"
    class="topbar-item"
    [hidden]="!(isHost || ('App.ChatFeature' | checkFeature)) || !chatConnected"
>
    <button [class]="customStyle">
        <div id="chatIconUnRead" *ngIf="unreadChatMessageCount">
            <i class="flaticon-chat-2 unread-notification"></i>
            <span class="label label-warning unread-chat-message-count">
                {{ unreadChatMessageCount }}
            </span>
        </div>
        <div id="chatIcon" *ngIf="!unreadChatMessageCount">
            <i class="flaticon-chat-2"></i>
        </div>
    </button>
</div>
